import { ICalculatorIntakeDemoGetCoverageRequestData } from "@common-shared/types/requestData/calculatorRequestData.types"
import type { ICalculatorResult } from "@common-shared/types/responseData/commonResponseData.types"

import { BrowserStorageType } from "@front-shared/config/general.config"
import { BrowserStorageHelper } from "@front-shared/helpers/browserStorage.helper"
import { UtilHelper } from "@front-shared/helpers/util.helper"

import { GENERAL_CONFIG } from "../config/general.config"
import { API_ROUTES } from "../config/routes.config"
import { HttpHelper } from "../helpers/http.helper"
import type {
    IGetCoverageInitialData,
    IGetCoveragePayerData,
} from "../types/data.types"

export class IntakeDemoService {
    /**
     * Check that provided auth token is valid
     */
    static async authorize(authToken: string): Promise<any> {
        const result = await HttpHelper.sendRequest(
            API_ROUTES.intakeDemoAuthorize,
            undefined,
            "POST",
            {
                [GENERAL_CONFIG.headers.authorization]: authToken,
            },
        )

        return result && !UtilHelper.isEmptyObject(result) && !result.errorData
            ? result
            : undefined
    }

    /**
     * Get coverage data based on collected data
     */
    static async getCoverage(
        initialData: IGetCoverageInitialData,
        payerData?: IGetCoveragePayerData,
    ): Promise<ICalculatorResult | undefined> {
        const { firstName, lastName, dob } = initialData.clientData

        const requestData: ICalculatorIntakeDemoGetCoverageRequestData = {
            firstName,
            lastName,
            dob: UtilHelper.dateToMysqlFormat(dob),

            ...(payerData
                ? {
                      payerId: payerData.insuranceData.payer.id,
                      memberId: payerData.insuranceData.memberId,
                  }
                : {}),
        }

        const result = await HttpHelper.sendRequest(
            API_ROUTES.intakeDemoGetCoverage,
            requestData,
            "GET",
            {
                [GENERAL_CONFIG.headers.authorization]:
                    BrowserStorageHelper.get(
                        GENERAL_CONFIG.browserStorageKeys.tokenKey,
                        undefined,
                        BrowserStorageType.sessionStorage,
                    ),
            },
        )

        return result && !UtilHelper.isEmptyObject(result) && !result.errorData
            ? result
            : undefined
    }
}
